import "./Searchers.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { DeleteOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  GroupsMessages,
  PageSetting,
  Query,
  SearcherMessages,
  SearcherRaw,
  SortMode,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/searchers/get-searchers-actions";
import { findById } from "../../../../controllers/store/actions/searchers/update-searchers-actions";
import { remove } from "../../../../controllers/store/actions/searchers/delete-searcher-action";
import { clear } from "../../../../controllers/store/actions/searchers/create-searcher-action";
import NewSearcherModal from "../../../components/Forms/Modal/Searchers/NewSearcher";
import UpdateSearcherModal from "../../../components/Forms/Modal/Searchers/UpdateSearcher";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;

const query: Query = { filter: {} };
const Groups: React.FC = () => {
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const searchersState = useSelector((state: any) => state.searchers);
  const updatedSearcherState = useSelector(
    (state: any) => state.updatedSearcher
  );
  const deletedSearcherState = useSelector(
    (state: any) => state.deletedSearcher
  );
  const createdSearcherState = useSelector(
    (state: any) => state.createdSearcher
  );
  const userState = useSelector((state: any) => state.user.user);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const columns: TableProps<SearcherRaw>["columns"] = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Email",
      dataIndex: "contact_email",
      key: "contact_email",
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Ciudad",
      dataIndex: "nme_municipio_res_pr",
      key: "nme_municipio_res_pr",
    },
    {
      title: "Clasificación",
      dataIndex: "nme_clasificacion_pr",
      key: "nme_clasificacion_pr",
    },
    {
      title: "Nivel de formación",
      dataIndex: "nme_niv_form_pr",
      key: "nme_niv_form_pr",
    },

    {
      title: "Área general",
      dataIndex: "nme_area_pr",
      key: "nme_area_pr",
    },

    {
      title: "Área especifica",
      dataIndex: "nme_esp_area_pr",
      key: "nme_esp_area_pr",
    },

    {
      title: "Gran área del conocimiento",
      dataIndex: "nme_gran_area_pr",
      key: "nme_gran_area_pr",
    },
    {
      title: "Instituciónn filial",
      dataIndex: "inst_filia",
      key: "inst_filia",
    },
    {
      title: "Fuente",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "Reconocimiento MinCiencia",
      dataIndex: "recognized_min",
      key: "recognized_min",
    },
    {
      title: "Fecha de expedición",
      dataIndex: "issue_date",
      key: "issue_date",
    },
    {
      title: "Vigencia",
      dataIndex: "current_date",
      key: "current_date",
    },
    {
      title: "Última actualización",
      dataIndex: "updated_at",
      key: "updated_at",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: SearcherRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              if (record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: SearcherMessages.Title,
                content: SearcherMessages.SearchersConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreatedSearcherMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: SearcherMessages.Title,
      description: SearcherMessages.SearcherCreated,
    });
    dispatch(clear());
    return null;
  };

  const showDeletedSearcherMessage = () => {
    api["success"]({
      key: 1,
      message: SearcherMessages.Title,
      description: SearcherMessages.SearchersDeleteSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const showUpdatedSearcherMessage = () => {
    api["success"]({
      key: 1,
      message: SearcherMessages.Title,
      description: SearcherMessages.SearcherUpdateSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    if (value) {
      query.search = value;
      query.meta = "filter_count";
    } else {
      delete query.search;
    }
    dispatch(find(1, pageSize, query));
  };

  useEffect(() => {
    dispatch(find(1, pageSize, {} as Query));
    setInitialDataLoaded(true);
  }, [pageSize]);

  return (
    <Layout className="searchers-layout">
      {contextHolder}
      {createdSearcherState.createdSearcher
        ? showCreatedSearcherMessageSuccess()
        : null}
      {deletedSearcherState.removed ? showDeletedSearcherMessage() : null}
      {updatedSearcherState.updatedSearcher
        ? showUpdatedSearcherMessage()
        : null}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="searchers-content">
        <Card className="searchers-card">
          <Col xs={24} sm={12} md={8} lg={12}>
            <h1 className="heading-content-title">
              Entidades
              <span className="heading-content-subtitle">Investigadores</span>
            </h1>
          </Col>
          <br />
          <NewSearcherModal
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateSearcherModal
            searcher={updatedSearcherState.searcher}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />

          {!initialDataLoaded && searchersState?.list?.length === 0 ? (
            <>
              <br />
              <br />
              <br />
              <br />
              <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{ height: 60 }}
                description={<span>No tienes investigadores aún</span>}
              >
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setVisibleCreateModal(!visibleCreateModal);
                  }}
                  type="primary"
                >
                  Agregar investigador
                </Button>
              </Empty>
              <br />
              <br />
              <br />
              <br />
            </>
          ) : (
            <>
              <Row gutter={[8, 8]} style={{ width: "100%", marginBottom: 20 }}>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-start"}>
                    <Search
                      placeholder="Buscar"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onSearch={handleSearch}
                      enterButton
                    />
                  </Flex>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-end"}>
                    <Button
                      type="primary"
                      onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                      size="middle"
                      icon={<PlusOutlined />}
                    >
                      Agregar investigador
                    </Button>
                  </Flex>
                </Col>
              </Row>
              <Skeleton
                loading={searchersState.isLoading}
                active
                className="full-width"
              >
                <Table
                  scroll={{ x: 3500 }}
                  sticky={{ offsetHeader: 0 }}
                  pagination={{
                    locale: {
                      jump_to: "Ir a",
                      items_per_page: "Items por pagina",
                    },
                    total:
                      searchersState.meta?.total_count ||
                      searchersState.meta?.filter_count,
                    current: page,
                    pageSize: PageSetting.limit,
                    onChange: (page) => {
                      dispatch(find(page, pageSize, query));
                      setPage(page);
                    },
                    onShowSizeChange: (pageSize) => {
                      dispatch(find(page, pageSize, query));
                      setPageSize(pageSize);
                    },
                  }}
                  locale={{ emptyText: "Sin Resultados." }}
                  columns={columns}
                  dataSource={searchersState.list}
                />
              </Skeleton>
            </>
          )}
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Groups;
